export const chainId = "56";
export const LUCKIFY_CONTRACT_ADDRESS =
  "0x13162F580ED79A07238F7d2BA7333264c319291c";
export const CRASH_GAME_CONTRACT = "0x13162F580ED79A07238F7d2BA7333264c319291c";

// export const USDT_CONTRACT_ADDRESS =
//
//   "0x55d398326f99059ff775485246999027b3197955";
export const LUCK_TOKEN = "0x0b515bD046705C10358A12c29Fd23377E7b34D25";
export const USDT_CONTRACT_ADDRESS =
  "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
export const CLAIMING_ADDRESS = "0xd93109416E2a1772f22C2eAcf2c18345ba809Dc1";
export const pool = "0xe47727F8c9256Ab31DD97D431dFE9a5d9C098238";
export const poolid =
  "0x3485f43b65eeeff859671341d6f92baa8f8008d66235ced70a3db7cb05bce1b9";
export const uniswapev4Contract = "0xd13Dd3D6E93f276FAfc9Db9E6BB47C1180aeE0c4";
// 0x5A03AfD25410b95BC97f8C6ab12B112d1e8e9BeD
export const me_client_api_key = "mee_3ZaHTVN39rCJTAQi7GfdAWEV";
export const ethNullAddress = "0x0000000000000000000000000000000000000000";
// export const bundlers =
export const ACTIVE_SESSION_TIME = Math.floor(Date.now() / 1000) + 60 * 60 * 24;
// ACTIVE_SESSION_TIME =
//   Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 5; // ONE HOUR
// "https://bundler.biconomy.io/api/v3/56/bundler_3Zeq8iYydDJUBsazojNJBHeU";
export const bundlers =
  "https://bundler.biconomy.io/api/v3/56/bundler_3ZNf6pKi6WMQ8ScfAeWMfSxM";

export const CHAIN_TO_TOKEN_ADDRESSES = {
  ARBITRUM: {
    USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    USDC: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    ETH: "0x0000000000000000000000000000000000000000",
  },
  BASE: {
    USDT: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    ETH: "0x0000000000000000000000000000000000000000",
  },
  BSC: {
    USDT: "0x55d398326f99059fF775485246999027B3197955",
    USDC: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    BNB: "0x0000000000000000000000000000000000000000",
  },
  ETHEREUM: {
    ETH: "0x0000000000000000000000000000000000000000",
    USDC: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  },
};

export const AQUA_SWAP_TX_STATUS = {
  PENDING: "PENDING",
  DEPOSITED: "DEPOSITED",
  IN_SWAP: "IN_SWAP",
  FINALIZED: "FINALIZED",
  REFUNDED: "REFUNDED",
  COMPLETED: "COMPLETED",
};
export const CHAIN_TO_TOKEN_MIN_AMOUNT = {
  ARBITRUM: {
    USDT: "$5",
    USDC: "$5",
    ETH: "0.0015 ETH",
  },
  BASE: {
    USDT: "$5",
    USDC: "$5",
    ETH: "0.0015 ETH",
  },
  BSC: {
    USDT: "$5",
    USDC: "$5",
    BNB: "0.005 BNB",
  },
  ETHEREUM: {
    ETH: "0.0015 ETH",
    USDC: "$5",
    USDT: "$5",
  },
};
